import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login-base',
  templateUrl: './login-base.component.html',
  styleUrls: ['./login-base.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginBaseComponent implements OnInit {
  @Input() pageHeader: string;
  constructor(
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
  }
}
